import {
  ClaimSpecialOfferDTO,
  CreatePaymentDTO,
  GetUpdateProgressPaymentLinkResponse,
  SpecialOfferWithContents,
  TransactionHistoryParams,
  TransactionHistoryResponse,
  TransactionStatus,
  TransactionStatusDTO,
} from './types'
import { http } from '@/shared/http.ts'

// export const postCreatePayment = async (token: string, data: SteamPaymentFormData) => {
//   const response = await axios.post(
//     `${baseUrl}/payment/create-payment/`,
//     {
//       country: data.country?.value,
//       currency: data.currency?.value,
//       payment_method: 2,
//       amount: Number(data.amount?.value),
//       login: data.login?.value,
//       amount_usd: Number(data.amount_usd?.value),
//     },
//     {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   )
//   return response.data
// }

export const getPaymentInfo = async (token: string) => {
  // TODO: clarify this type
  return await http.get<any>('/payment/info', {
    token,
  })
}

export const getCurrencyRate = async (token: string) => {
  // TODO: clarify this type
  return await http.get<any>('/payment/rates', {
    token,
  })
}

export const getTransactionHistory = async ({token, page, size}: TransactionHistoryParams): Promise<TransactionHistoryResponse> => {
  return await http.get<TransactionHistoryResponse>('/payment/all-history', {
    token,
    queryParams: {
      page,
      size,
    }
  })
}

export const getUpdateProgressInvoiceLink = async (token: string): Promise<GetUpdateProgressPaymentLinkResponse> => {
  return await http.get<GetUpdateProgressPaymentLinkResponse>('/payment/scoring', {
    token,
  })
}
export const getTransactionStatus = async ({token, tx_id}: TransactionStatusDTO): Promise<TransactionStatus> => {
  return await http.get<TransactionStatus>('/payment/ton/transaction-status', {
    token,
    queryParams: {
      tx_id,
    }
  })
}
export const postCreatePayment = async ({token, amount, id: key_id, tx_id}: CreatePaymentDTO) => {
  return await http.post(
    '/payment/ton/create-payment',
    {
      token,
      body: {
        key_id,
        amount,
        tx_id,
      }
    },
  )
}

export const getScoringInvoice = async (token: string): Promise<GetUpdateProgressPaymentLinkResponse> => {
  return await http.get<GetUpdateProgressPaymentLinkResponse>('/payment/scoring', {
    token,
  })
}
export const getSpecialOffer = async (token: string): Promise<SpecialOfferWithContents> => {
  return await http.get<SpecialOfferWithContents>('/payment/special-offer', {
    token,
  })
}

export const postBuySpecialOffer = async ({token, offer_id}: ClaimSpecialOfferDTO) => {
  return await http.post<{ invoice_url: string }>(
    '/payment/buy-special-offer/',
    {
      token,
      body: {
        offer_id,
      }
    },
  )
}
